module.exports = __webpack_public_path__ + "static/gallery-gradient-79d064ca702edbe6fe9017e780c7b447.png";